import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { companyInfo } from '../../data/mock';
import StarburstDecor from '../ui/StarburstDecor';

const AboutSection = () => {
  return (
    <section className="bg-lime py-16">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image/Collage Area */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="bg-white rounded-lg overflow-hidden aspect-[4/5] shadow-lg">
                  <img
                    src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&q=80"
                    alt="Team collaboration"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="bg-white rounded-lg overflow-hidden aspect-square shadow-lg">
                  <img
                    src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&q=80"
                    alt="Office work"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="bg-white rounded-lg overflow-hidden aspect-square shadow-lg">
                  <img
                    src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&q=80"
                    alt="Design work"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="bg-white rounded-lg overflow-hidden aspect-[4/5] shadow-lg">
                  <img
                    src="https://images.unsplash.com/photo-1573164713988-8665fc963095?w=400&q=80"
                    alt="Creative process"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <StarburstDecor size={80} color="lime" />
            </div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy font-display mb-6">About Us</h2>
            <p className="text-navy/80 leading-relaxed mb-4 text-sm">
              {companyInfo.name} is a creative digital agency based in Tbilisi, Georgia. 
              We specialize in creating visually appealing brands, websites, and products 
              for technology startups and companies.
            </p>
            <p className="text-navy/80 leading-relaxed mb-6 text-sm">
              Our focus is on creating visually appealing brands that resonate with 
              your target audience and help you achieve your business goals.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-navy text-white px-6 py-3 rounded-full text-sm font-medium"
            >
              More
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
